import { CompetencyArea } from '@/types/interview'

// Frontend competency names MUST exactly match backend CompetencyArea enum values
export const COMPETENCY_AREAS: CompetencyArea[] = [
  {
    id: 'cultural_fit',
    name: 'Cultural Fit',
    displayName: 'Cultural Fit',
    maxQuestions: 5, // AI can ask up to 5 questions if needed
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'technical_skills',
    name: 'Technical Skills',
    displayName: 'Technical Skills',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'problem_solving',
    name: 'Problem Solving',
    displayName: 'Problem Solving',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'communication',
    name: 'Communication',
    displayName: 'Communication',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'relevance_to_job_role',
    name: 'Relevance to Job Role',
    displayName: 'Job Relevance',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'success_prediction',
    name: 'Success Prediction Score',
    displayName: 'Success Prediction',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'turnover_risk',
    name: 'Turnover Risk',
    displayName: 'Turnover Risk',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'proactivity',
    name: 'Proactivity Score',
    displayName: 'Proactivity',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'learning_ability',
    name: 'Learning Ability',
    displayName: 'Learning Ability',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'skill_match',
    name: 'Skill Match (Key Competencies)',
    displayName: 'Skill Match',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'work_history_strength',
    name: 'Work History Strength',
    displayName: 'Work History',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  },
  {
    id: 'leadership',
    name: 'Leadership',
    displayName: 'Leadership',
    maxQuestions: 5,
    questionsAsked: 0,
    completed: false
  }
]

export const COMPETENCY_SEQUENCE = COMPETENCY_AREAS.map(area => area.name)

export const DEFAULT_INTERVIEW_CONFIG = {
  maxQuestionsPerCompetency: 5, // Dynamic: AI can ask 3-5 questions based on candidate performance
  targetQuestionsPerCompetency: 3, // Target: 3 questions per competency for good performers
  competencySequence: COMPETENCY_SEQUENCE,
  timeLimit: 45 * 60 // 45 minutes in seconds
}